// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"125":"bc8ecbb4","497":"c3643c32","578":"c4fe846c","641":"78010842","705":"0a97a231","778":"672c14b3","884":"e9f1eb13"}[chunkId] + ".chunk.js";
};